import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as registerSelectors from './selectors';

export default reducer;
